import React, { Fragment } from 'react';
import personalaccess from '../../../../../images/personalaccess.png';
import '../../driverFaq.css';

const PersonalVehicleAccess = () => (
  <Fragment>
    <p>
      Enter through the parking lot ramp and the gate will open
      automatically. Drive down to P4 (Level D) and you can park your
      personal vehicle for free in the assigned Autzu parking spot stated
      on your Dashboard.
    </p>
    <div style={{ textAlign: 'center', width: '100%' }}>
      <img src={personalaccess} className="personal-image" />
    </div>
    <br />
  </Fragment>
);

export default PersonalVehicleAccess;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/ParkingHub/King/PersonalVehicleAccess.js